import React from 'react';
import { userManagementRoute } from '@/modules/administration/user-management/routes';
import { USER_ORDER_VALUES } from '@/modules/administration/user-management/users/routes';
import { createRoute } from '@tanstack/react-router';
import z from 'zod';

const groupDetailsSearchParamsSchema = z.object({
  page: z.coerce.number().min(1).default(1),
  size: z.coerce.number().min(1).default(20),
  sort: z.enum(['id']).default('id'),
  order: z.enum(USER_ORDER_VALUES).default('desc'),
  email: z.string().optional(),
});

export const groupsDetailRoute = createRoute({
  getParentRoute: () => userManagementRoute,
  path: 'groups/$groupId',
  wrapInSuspense: true,
  component: React.lazy(
    async () => await import('@/app/routes/Admin/Users/UserGroupList/UserGroupDetail')
  ),
  validateSearch: (search) => {
    const result = groupDetailsSearchParamsSchema.safeParse(search);
    if (!result.success) throw result.error;
    return result.data;
  },
});
